import { render } from "./PostponementsListEntry.vue?vue&type=template&id=19d6375c&scoped=true&ts=true"
import script from "./PostponementsListEntry.vue?vue&type=script&lang=ts"
export * from "./PostponementsListEntry.vue?vue&type=script&lang=ts"

import "./PostponementsListEntry.vue?vue&type=style&index=0&id=19d6375c&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d6375c"]])

export default __exports__